<template>
  <div class="app-brand-header" :class="[`variant-${variant}`, { 'has-subtitle': !!subtitle }]">
    <EverglanceMark :size="logoSize" />
    <div class="app-brand-copy">
      <AppBrandWordmark :as="titleAs" :size="wordmarkSize" />
      <p v-if="subtitle" class="app-brand-subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import EverglanceMark from '@/components/brand/EverglanceMark.vue'
import AppBrandWordmark from '@/components/brand/AppBrandWordmark.vue'

const props = defineProps({
  variant: {
    type: String,
    default: 'login',
    validator: (value) => ['login', 'nav', 'sidebar'].includes(value)
  },
  subtitle: {
    type: String,
    default: ''
  },
  titleAs: {
    type: String,
    default: 'h1'
  }
})

const logoSize = computed(() => {
  if (props.variant === 'login') return 52
  if (props.variant === 'sidebar') return 36
  return 28
})

const wordmarkSize = computed(() => {
  if (props.variant === 'login') return 'lg'
  if (props.variant === 'sidebar') return 'sm'
  return 'sm'
})
</script>

<style scoped>
.app-brand-header {
  display: flex;
  align-items: center;
}

.variant-login {
  flex-direction: row;
  justify-content: center;
  gap: 0.85rem;
  text-align: left;
}

.variant-nav,
.variant-sidebar {
  gap: 0.65rem;
  min-width: 0;
}

.app-brand-copy {
  min-width: 0;
}

.app-brand-subtitle {
  margin: 0.15rem 0 0;
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--text-secondary, #5a6578);
}

.variant-sidebar .app-brand-subtitle {
  font-size: 0.78rem;
}
</style>
